import { createFileRoute } from '@tanstack/react-router'
import { ScScribePage } from '@/features/support-coordination/scribe'

export const Route = createFileRoute(
  '/_authenticated/_organization/support-coordination/scribe',
)({
  component: ScScribePage,
})
